import { Controller } from "@hotwired/stimulus";
import userManager from "../vanilla/backend/user_manager.js";
import gameTokenLobby from "../vanilla/game_token_lobby.js";

interface LobbyUser {
	user_id: number;
	user_obj: { name: string; email: string; actorId: null };
}

interface FillLobbyResponse {
	users: LobbyUser[];
	lobby_status: string;
}

export default class FillTokenLobbyController extends Controller {
	static values = { url: String };

	declare readonly urlValue: string;

	async fill(): Promise<void> {
		const response = await fetch(this.urlValue, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"X-CSRF-Token":
					document
						.querySelector('meta[name="csrf-token"]')
						?.getAttribute("content") ?? "",
			},
		});
		if (!response.ok) {
			return;
		}
		const { users, lobby_status }: FillLobbyResponse = await response.json();
		for (const { user_id, user_obj } of users) {
			gameTokenLobby.updateLobbyUserEntryMultipleProps(user_id, user_obj);
		}
		if (lobby_status === "lobby_full") {
			userManager.markLobbyAsFull();
			this.element.remove();
		}
	}
}
